import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import styles from "../../Styles/featureSlider.module.scss";

import share1 from '../../Assets/ProFeatures/share.webp';
import addcolors1 from '../../Assets/ProFeatures/addcolors.webp';
import saved1 from '../../Assets/ProFeatures/saved.webp';
import accessibility1 from '../../Assets/ProFeatures/accessibility.webp';
import export1 from '../../Assets/ProFeatures/export.webp';
import random1 from '../../Assets/ProFeatures/random.webp';
import editvariable1 from '../../Assets/ProFeatures/editvariable.webp';
import editscale1 from '../../Assets/ProFeatures/editscale.webp';
import figmaplugin1 from '../../Assets/ProFeatures/figmaplugin.webp';
import inspiration1 from '../../Assets/ProFeatures/inspiration.webp'
import OrganicAnimation from '../OrganicAnimation';

function FeaturesSlider() {
  return (
    <div className={styles.featuresWrap}>
      <div className={styles.anim}>
        <OrganicAnimation speed={0.5} spread={3} />
      </div>

      <span className={styles.perksTitle}>
        More than just colors
      </span> 

      <Swiper
        modules={[Navigation, Pagination, A11y, Autoplay]}
        spaceBetween={4}
        // slidesPerView={3}            
        centeredSlides={true}
        initialSlide={0}                    // ← start on slide 2 (index 1)
        loop={true}                         // ← needed so it wraps around
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,      // keeps autoplay going after user clicks
          pauseOnMouseEnter: false,          // pauses when hovering — 
        }}
        navigation
        pagination={{ clickable: true }}
        breakpoints={{
          0: { slidesPerView: 1 },
          576: { slidesPerView: 3 },
        }}
        observer={true}
        observeParents={true}
        className={styles.perksSwiper}
      >
        {/* share */}
        <SwiperSlide>
          <div className={styles.perksListItem}>
            <span className={styles.perkTitle}>
              <svg className="check-icon-fill" width={24} height={24} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
              </svg>
              Share
            </span>
            <span className={styles.perkDescription}>Generate shareable links to present your color scales or palettes to clients</span>
            <img src={share1} alt="" />
          </div>
        </SwiperSlide>

        {/* add colors */}
        <SwiperSlide>
          <div className={styles.perksListItem}>
            <span className={styles.perkTitle}>
              <svg className="check-icon-fill" width={24} height={24} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
              </svg>
              Add colors</span>
            <span className={styles.perkDescription}>Add and preview secondary & tertiary color scales</span>
            <img src={addcolors1} alt="" />
          </div>
        </SwiperSlide>

        {/* save */}
        <SwiperSlide>
          <div className={styles.perksListItem}>
            <span className={styles.perkTitle}>
              <svg className="check-icon-fill" width={24} height={24} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
              </svg>
              Save</span>
            <span className={styles.perkDescription}>Save scales or palettes directly to your account for quick access</span>
            <img src={saved1} alt="" />
          </div>
        </SwiperSlide>

        {/* accessibility */}
        <SwiperSlide>
          <div className={styles.perksListItem}>
            <span className={styles.perkTitle}>
              <svg className="check-icon-fill" width={24} height={24} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
              </svg>
              Accessibility</span>
            <span className={styles.perkDescription}>Instantly check accessibility with our built-in Contrast Grid</span>
            <img src={accessibility1} alt="" />
          </div>
        </SwiperSlide>

        {/* export */}
        <SwiperSlide>
          <div className={styles.perksListItem}>
            <span className={styles.perkTitle}>
              <svg className="check-icon-fill" width={24} height={24} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
              </svg>
              Export</span>
            <span className={styles.perkDescription}>Export in OKLCH, HSL and RGB format (incl. SCSS and CSS)</span>
            <img src={export1} alt="" />
          </div>
        </SwiperSlide>

        {/* edit variables */}
        <SwiperSlide>
          <div className={styles.perksListItem}>
            <span className={styles.perkTitle}>
              <svg className="check-icon-fill" width={24} height={24} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
              </svg>
              Edit variables</span>
            <span className={styles.perkDescription}>Fine-tune or reset individual variable colors by hue, saturation, or lightness</span>
            <img src={editvariable1} alt="" />
          </div>
        </SwiperSlide>

        {/* edit scale  */}
        <SwiperSlide>
          <div className={styles.perksListItem}>
            <span className={styles.perkTitle}>
              <svg className="check-icon-fill" width={24} height={24} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
              </svg>
              Edit scales</span>
            <span className={styles.perkDescription}>Fine-tune or reset scale colors by hue, saturation, or lightness</span>
            <img src={editscale1} alt="" />
          </div>
        </SwiperSlide>

        {/* figma plugin */}
        <SwiperSlide>
          <div className={styles.perksListItem}>
            <span className={styles.perkTitle}>
              <svg className="check-icon-fill" width={24} height={24} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
              </svg>
              Figma plugin</span>
            <span className={styles.perkDescription}>Get access to all premium features in the <a className={styles.figmaPluginLink} href="https://www.figma.com/community/plugin/1544422242387734389" target="_blank" rel="noopener noreferrer">No61 Figma plugin</a></span>
            <img src={figmaplugin1} alt="" />
          </div>
        </SwiperSlide>

        {/* random */}
        <SwiperSlide>
          <div className={styles.perksListItem}>
            <span className={styles.perkTitle}>
              <svg className="check-icon-fill" width={24} height={24} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
              </svg>
              Palette generation</span>
            <span className={styles.perkDescription}>Generate both individual scales and complete palettes</span>
            <img src={random1} alt="" />
          </div>
        </SwiperSlide>

        {/* inspiration */}
        <SwiperSlide>
          <div className={styles.perksListItem}>
            <span className={styles.perkTitle}>
              <svg className="check-icon-fill" width={24} height={24} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
              </svg>
              Inspiration</span>
            <span className={styles.perkDescription}>Get access to duo and trio palette themes</span>
            <img src={inspiration1} alt="" />
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  )
}

export default FeaturesSlider